import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {
  Observable,
  interval,
  startWith,
  map,
  takeWhile,
  of,
  Subscription,
} from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { environment } from 'src/app/environments/environments';
import moment from 'moment';
@Component({
  selector: 'app-host-visitor-status',
  templateUrl: './host-visitor-status.component.html',
  styleUrl: './host-visitor-status.component.scss',
})
export class HostVisitorStatusComponent implements OnInit, OnDestroy {
  @ViewChild('FailedErrorDialog', { static: true })
  failedErrorDialog: TemplateRef<any>;
  @ViewChild('VisitorMeetingComments', { static: true })
  visitorMeetingComments: TemplateRef<any>;

  @ViewChild('InProgresslDialog', { static: true })
  inProgresslDialog: TemplateRef<any>;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  token = '';
  isFetchingRequest = false;
  isFetched: boolean = false;
  visitors: Visitor[] = [];
  currentVisitorId: string = null;
  isOpen = false;
  subscriptions: Subscription[] = [];
  intervals: { [key: string]: Subscription } = {};
  isDialog: boolean = false;
  displayedColumns = [
    'no',
    'visname',
    'hostname',
    'date',
    'purpose',
    'security',
    'Details',
  ];
  baseServerURL = environment.apiUrl;
  constructor(
    private _formbuilder: FormBuilder,
    public dialog: MatDialog,
    private screen: AumyeResponsiveScreenService,
    private activeRoute: ActivatedRoute,
    private httpclient: HttpClient,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.activeRoute.queryParams.subscribe((params) => {
      this.token = params['data'];
    });
  }
  visitorPreVerifiedForm = this._formbuilder.group({
    orgId: [],
    visitorID: [],
    hostUserId: [],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.email]],
    phoneNumber: ['', Validators.required],
    visitorAddress: [],
    gender: [],
    purpose: ['', Validators.required],
    carRegistration: [],
    identityID: [''],
    hostName: ['', Validators.required],
    profilePicture: [''],
    securityStatus: [''],
    qrCode: [''],
    visitDateTime: [''],
    passValidity: [],
    checkIn: [],
    checkOut: [],
    meetingComments: [''],
    sendVisitor: [''],
    inProgressStatusTime: [''],
    visitorCommentsTimeline: [''],
    VisitorTimline: [''],
  });
  meetingCommentForm = this._formbuilder.group({
    meetingComment: ['', Validators.required],
    sendVisitor: ['', Validators.required],
  });

  ngOnInit(): void {
    if (this.token) {
      this.baseServerURL =
        this.baseServerURL + 'GetHostVisitors?data=' + this.token;
      this.fetchUserDetails();
    } else {
      this.isDialog = true;
      this.visitors = this.data;
      this.baseServerURL =
        this.baseServerURL + 'GetHostVisitors?visitorId=' + this.visitors;
      this.fetchUserDetails();
    }
  }
  fetchUserDetails() {
    this.isFetchingRequest = true;
    this.httpclient.get(this.baseServerURL).subscribe({
      next: (res: any) => {
        this.visitors = res;
        this.isFetched = true;
        this.isFetchingRequest = false;
        this.initializeTimers();
      },
      error: (error: any) => {
        this.isFetchingRequest = false;
        this.dialog.open(this.failedErrorDialog, {
          disableClose: true,
        });
      },
    });
  }
  initializeTimers() {
    this.visitors.forEach((visitor) => {
      this.startTimer(visitor);
    });
  }
  startTimer(visitor: Visitor) {
    if (visitor.securityStatus === 4 && visitor.inProgressStatusTime) {
      const subscription = interval(1000).subscribe(() => {
        this.updateTimer(visitor);
      });
      this.subscriptions.push(subscription);
    } else if (
      (visitor.securityStatus === 5 || visitor.securityStatus === 1) &&
      visitor.completeStatusTime
    ) {
      const completeStatusTime = new Date(visitor.completeStatusTime);
      const inProgressStatusTime = new Date(visitor.inProgressStatusTime);
      const diff =
        completeStatusTime.getTime() - inProgressStatusTime.getTime();
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      visitor.timerValue = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
        seconds
      )}`;
    }
  }
  updateTimer(visitor: Visitor) {
    const now = new Date();
    const currentTimeUTC = new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const inProgressTimeUTC = new Date(visitor.inProgressStatusTime).getTime();
    const diff = currentTimeUTC.getTime() - inProgressTimeUTC;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    visitor.timerValue = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
      seconds
    )}`;
  }

  pad(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
  cleanupTimers() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  refreshWindow() {
    if (this.isDialog) {
      this.fetchUserDetails();
    } else window.location.reload();
  }
  toggleDetails(val: Visitor) {
    if (this.currentVisitorId) {
      if (this.currentVisitorId === val.visitorID && this.isOpen) {
        this.isOpen = false;
        this.currentVisitorId = null;
      } else {
        this.isOpen = true;
      }
    } else {
      this.isOpen = true;
    }
    this.currentVisitorId = val.visitorID;
    if (this.isOpen) {
      this.visitorPreVerifiedForm.reset();
      this.setFormData(val);
    }
  }
  setFormData(val: Visitor) {
    this.visitorPreVerifiedForm.controls.orgId.setValue(val.orgID);
    this.visitorPreVerifiedForm.controls.visitorCommentsTimeline.setValue(
      val.visitorCommentsTimeline
    );
    this.visitorPreVerifiedForm.controls.VisitorTimline.setValue(
      val.visitorTimline
    );
    this.visitorPreVerifiedForm.controls.visitDateTime.setValue(
      val.visitDateTime
    );
    this.visitorPreVerifiedForm.controls.visitorID.setValue(val.visitorID);
    this.visitorPreVerifiedForm.controls.firstName.setValue(val.firstName);
    this.visitorPreVerifiedForm.controls.lastName.setValue(val.lastName);
    this.visitorPreVerifiedForm.controls.email.setValue(val.email);
    this.visitorPreVerifiedForm.controls.phoneNumber.setValue(val.phoneNumber);
    this.visitorPreVerifiedForm.controls.hostUserId.setValue(val.hostUserId);
    this.visitorPreVerifiedForm.controls.hostName.setValue(val.hostName);
    this.visitorPreVerifiedForm.controls.inProgressStatusTime.setValue(
      val.inProgressStatusTime
    );
    // this.visitorPreVerifiedForm.controls.passValidity.setValue(
    //   val.ePassValidity
    // );
    const ePassValidity = new Date(val.ePassValidity + 'Z');
    this.visitorPreVerifiedForm.controls.passValidity.setValue(
      moment(ePassValidity).format('DD/MM/YYYY, h:mm:ss A')
    );
    this.visitorPreVerifiedForm.controls.visitorAddress.setValue(
      val.visitorAddress
    );
    this.visitorPreVerifiedForm.controls.purpose.setValue(val.purpose);
    if (val.checkIn != null)
      this.visitorPreVerifiedForm.controls.checkIn.setValue(
        new Date(val.checkIn + 'Z').toLocaleString()
      );
    if (val.checkOut != null)
      this.visitorPreVerifiedForm.controls.checkOut.setValue(
        new Date(val.checkOut).toLocaleString()
      );
    this.visitorPreVerifiedForm.controls.carRegistration.setValue(
      val.carRegistration
    );
    this.visitorPreVerifiedForm.controls.profilePicture.setValue(
      val.profilePicture
    );
    this.visitorPreVerifiedForm.controls.securityStatus.setValue(
      val.securityStatus.toString()
    );
    this.visitorPreVerifiedForm.controls.meetingComments.setValue(
      val.meetingComments == null ? 'No Comments' : val.meetingComments
    );
    this.visitorPreVerifiedForm.controls.identityID.setValue(val.identityID);
  }
  onCompleteOpenDialog() {
    const dialogRef = this.dialog.open(this.visitorMeetingComments, {
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.visitorPreVerifiedForm.controls.meetingComments.setValue(
          this.meetingCommentForm.controls.meetingComment.value
        );
        this.visitorPreVerifiedForm.controls.sendVisitor.setValue(
          this.meetingCommentForm.controls.sendVisitor.value
        );
        this.onClickStatusInprogress(5);
      }
    });
  }
  onClickStatusInprogress(val: number) {
    const dialogRef = this.dialog.open(this.inProgresslDialog, {
      disableClose: true,
    });
    let baseServerURL = environment.apiUrl + 'UpdateVisitorsStatus';
    this.visitorPreVerifiedForm.controls.securityStatus.setValue(
      val.toString()
    );
    this.visitorPreVerifiedForm.controls.checkIn.setValue('');
    this.visitorPreVerifiedForm.controls.checkOut.setValue('');
    let data = this.visitorPreVerifiedForm.value;
    this.httpclient
      .post(baseServerURL, data, { responseType: 'text' })
      .subscribe({
        next: (res: any) => {
          dialogRef.close();
          this.fetchUserDetails();
        },
        error: (error: any) => {
          dialogRef.close();
          this.dialog.open(this.failedErrorDialog, {
            disableClose: true,
          });
        },
      });
  }
  ngOnDestroy() {
    this.cleanupTimers();
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  getFormatedDate(val: any) {
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
}
